// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { createUserWithEmailAndPassword, getAuth, signInWithEmailAndPassword } from "firebase/auth"
import { createContext, useContext, useState, useEffect } from "react";
import { collection, doc, getFirestore } from "firebase/firestore";
import { studySetConverter } from "../models/StudySet";
import { questionConverter } from "../models/Question";
import { answerConverter } from "../models/Answer";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCCGJaUvGU5E7nirV4vGZl7QvZuuKnhHQ0",
  authDomain: "study-tool-8c181.firebaseapp.com",
  projectId: "study-tool-8c181",
  storageBucket: "study-tool-8c181.appspot.com",
  messagingSenderId: "1097467007955",
  appId: "1:1097467007955:web:ca176b006c9c7955709526",
  measurementId: "G-BB1RGRQ4DH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
export const db = getFirestore(app);

export const COLLECTIONS = {
  questions: "questions",
  studySets: "studySets",
  answers: "answers"
}

const converterMap = {
  questions: questionConverter,
  studySets: studySetConverter,
  answers: answerConverter
}

// collections
export function getCollection(collectionID) {
  return collection(db, collectionID).withConverter(converterMap[collectionID])
}

export function getDocRef(collectionID, docID) {
  return doc(db, collectionID, docID).withConverter(converterMap[collectionID])
}

// export const questionsCollection = collection(db, "questions").withConverter(questionConverter)
// export const studySetsCollecstion = collection(db, "studySets").withConverter(studySetConverter)
// export const getStudySetDocRef = (id) => {
//   return doc(db, "studySets", id).withConverter(studySetConverter)
// }
// export const getQuestionDocRef = (id) => {
//   return doc(db, "questions", id).withConverter(questionConverter)
// }

// authentication
export const userContext = createContext({ user: null })
export const useSession = () => {
  const { user } = useContext(userContext)
  return user
}
export const useAuth = () => {
  const [state, setState] = useState(() => {
    const user = auth.currentUser
    return {
      initializing: !user,
      user
    }
  })

  function onChange(user) {
    setState({ initializing: false, user })
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(onChange)
    return () => unsubscribe()
  }, [])

  return state
}

export const createAccount = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password)
    console.log('created new account')
    logFirebaseEvent('sign_up', { provider: 'email' })
    return true
  } catch (error) {
    alert(error.message)
    return false
  }
}

export const logout = async () => {
  logFirebaseEvent('log_out', null)
  await auth.signOut()
}

export const logIn = async (email, password) => {
  const success = await signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
    console.log("successful login...")
    logFirebaseEvent('log_in', { provider: 'email' })
    return true
  }).catch((error) => {
    alert(error.message)
    return false
  })
  return success
}

export const logFirebaseEvent = async (name, paramsDict) => {
  logEvent(analytics, name, paramsDict)
}